import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { AppliancePackage } from './AppliancePackage';

export const AppliancePackageContainer = () => {
  return (
    <QueryProvider cacheKey="package-experience-appliance">
      <AppliancePackage />
    </QueryProvider>
  )
};